import type React from "react";
import { createContext } from "react";

export type ILicenseDefinitionsScreenContext = {
	connectionId: string;
	setConnectionId: React.Dispatch<string>;
};

export const LicenseDefinitionsScreenContext = createContext<ILicenseDefinitionsScreenContext>({
	connectionId: "",
	setConnectionId: () => {},
});
